export default {
  saveSuccessMsg: '保存成功！',
  changeLanguageTips: '切換語言成功',
  modifyPwdSuccess: '密碼修改成功！',
  noFileMsgOrError: '沒有文件信息或文件報錯',
  immutableInfo: '該學生信息不可修改！',
  unknownError: '未知錯誤，請聯系管理員！',
  expired: '認證已過期',
}
